import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { environment } from './../../environments/environment';
import * as firebase from 'firebase';


@Component({
  selector: 'contract-article',
  templateUrl: './contract-article.component.html',
  styleUrls: ['./contract-article.component.css']
})
export class ContractArticleComponent implements OnInit {

  @Input()
  article: any;

  @Input()
  sides: any;

  @Input()
  articleNumber: any;

  @Input()
  enumerate: boolean;

  @Input()
  noArticleTitle: boolean;

  @Output()
  onDeleteArticle = new EventEmitter<any>();

  @Output()
  onDeleteStatement = new EventEmitter<any>();

  @Output()
  onAddArticle = new EventEmitter<any>();

  tags = [];

  hasTitle = false;
  isSignature = false;
  isPlaceandDate = false;

  constructor(private router: Router) { }

  // ngAfterContentChecked() {
  //   console.log('davaj');
  //   $.each($(".statement-textarea"), function (i, element) {
  //     element.style.height = 'auto';
  //     element.style.height = element.scrollHeight + "px";
  //   });
  // }

  ngOnInit() {
    if (environment.production && !firebase.auth().currentUser) {
      this.router.navigate(['/']);
    };
    this.tags = this.generateTags();
    this.hasTitle = this.article.type !== 2 && this.article.type !== 3; // TODO: enum
    this.isSignature = this.article.type === 3;
    this.isPlaceandDate = this.article.type === 2;
  }
 /**
   * Generates article tags based on article content.
   */
  generateTags() {
    let tags = [];

    let isEditable = false;
    let isMultiple = false;
    let isInput = false;
    for (let i = 0; i < this.article.statements.length; i++) {
      if (this.article.statements[i].editable) {
        isEditable = true;
      }
      if (this.article.statements[i].type == "choice") {
        isMultiple = true;
        if (this.article.statements[i].choices) {
          for (let j = 0; j < this.article.statements[i].choices.length; j++) {
            if (this.article.statements[i].choices[j].parts) {
              for (let k = 0; k < this.article.statements[i].choices[j].parts.length; k++) {
                if (this.article.statements[i].choices[j].parts[k].type == "input" || this.article.statements[i].choices[j].parts[k].type == "textarea" ) {
                  isInput = true;
                }
              }
            }
          }
        }
      }
      // Krešo - ovdje pogledati - možda je tu rješenje ovoga oko pravljenja proreda u HTML-u; da je slično kao gore od 80-og
      if (this.article.statements[i].type == "input") {
        isInput = true;

        // ----------------- pokušaj popravka contenta
        // if (this.article.statements[i].parts) {
        //   for (let k = 0; k < this.article.statements[i].parts.length; k++) {
        //     if (this.article.statements[i].parts[k].type == "text") {
        //       this.article.statements[i].parts[k].content = this.article.statements[i].parts[k].content.split('\r\n').join('<br>');
        //     }
        //   }
        // }
        //-----------------

      }
      if (this.article.statements[i].type == "textarea") {
        isInput = true;
      }
    }

    tags.push(this.article.mandatory ? {  title: "NEIZBRISIV ČLANAK/TOČKA", class: "danger rounded-pill", icon:"glyphicon glyphicon-alert" } : { title: " IZBRISIV ČLANAK/TOČKA", class: "success rounded-pill", icon:"remove" });
    tags.push(isEditable ? { title: "  IZMJENJIV SADRŽAJ", class: "success rounded-pill",  icon:"glyphicon glyphicon-edit" } : { title: "  NEIZMJENJIV SADRŽAJ", class: "danger rounded-pill", icon: "glyphicon glyphicon-alert" });

    if (isMultiple) { tags.push({ title: "POTREBAN ODABIR", class: "primary rounded-pill",  icon:"glyphicon glyphicon-check" }); }
    if (isInput) { tags.push({ title: "POTREBAN UNOS", class: "primary rounded-pill", icon:"glyphicon glyphicon-pencil" }); }

    if (this.article.exampleContent) { tags.push({ title: "POTREBNO IZMIJENITI ", class: "primary rounded-pill", icon:"glyphicon glyphicon-wrench" }); }

    return tags;
  }


  /**
   * Converts number to it's roman numerals equivalent representation.
   * Source: http://blog.stevenlevithan.com/archives/javascript-roman-numeral-converter
   * @param num Number to covert.
   */
  romanize(num) {
    if (!+num)
      return NaN;
    var digits = String(+num).split(""),
      key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
        "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
        "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
      roman = "",
      i = 3;
    while (i--)
      roman = (key[+digits.pop() + (i * 10)] || "") + roman;
    return Array(+digits.join("") + 1).join("M") + roman;
  }

  deleteArticle(article: any) {
    this.onDeleteArticle.emit(article);
  }

  deleteStatement(statement: any) {
    this.onDeleteStatement.emit(statement);
  }

  addArticle(article: any) {
    this.onAddArticle.emit(article);
  }

  removePlaceholder() {
    console.log('ovo: ', this)
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract-article/contract-article.component.ts